import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridHeaderMenuDirective } from './grid-header-menu.directive';

@NgModule({
  declarations: [
    GridHeaderMenuDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GridHeaderMenuDirective
  ]
})
export class GridHeaderMenuModule { }
